import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { SERVICES } from '@/lib/data';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
export function Services() {
  return (
    <section id="services" className="py-20 md:py-32 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-brand-lime font-bold tracking-widest uppercase text-sm mb-4">Expertise</h2>
            <h3 className="text-4xl md:text-5xl font-display font-bold text-brand-purple mb-6">
              Nos services 360° pour votre <span className="text-brand-purple/60 italic underline decoration-brand-lime decoration-4 underline-offset-8">succès digital</span>
            </h3>
            <p className="text-lg text-brand-purple/60 text-pretty">
              Une approche personnalisée pour chaque projet, combinant data, design et technologie pour des résultats mesurables.
            </p>
          </motion.div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {SERVICES.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full border border-gray-100 shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 group overflow-hidden bg-white">
                <CardHeader className="pb-4">
                  <div className={cn(
                    "w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3 shadow-sm",
                    service.color
                  )}>
                    <service.icon className="w-7 h-7" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-brand-purple group-hover:text-brand-purple-light transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-brand-purple/70 text-base leading-relaxed text-pretty">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}